import {FormControl, FormField} from 'platform/components';
import {Grid, VStack} from 'platform/foundation';

import {UseFormReturn, useWatch} from 'react-hook-form';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {ageTypeOptions} from '../constants/ageTypeOptions';
import {DiscountFormType} from '../types/DiscountFormType';

interface VehicleAgeFieldsProps extends TestIdProps {
  control: FormControl<DiscountFormType>;
  formApi: UseFormReturn<DiscountFormType>;
}

export function VehicleAgeFields(props: VehicleAgeFieldsProps) {
  const vehicleAgeType = useWatch({control: props.control, name: 'vehicleAgeType'});

  return (
    <VStack spacing={3}>
      <FormField
        control={props.control}
        name="vehicleAgeType"
        type="radio"
        options={ageTypeOptions}
        label={i18n.t('entity.vehicle.labels.vehicleAge')}
        onChange={() => {
          props.formApi.setValue('vehicleAgeFrom', undefined);
          props.formApi.setValue('vehicleAgeTo', undefined);
        }}
        data-testid={suffixTestId('vehicleAgeType', props)}
      />
      <Grid columns={[1, 2]} spacing={4}>
        <FormField
          control={props.control}
          name="vehicleAgeFrom"
          type="integer"
          label={i18n.t('entity.customerContract.labels.ageFrom')}
          isDisabled={vehicleAgeType !== 'VEHICLE_AGE_IN_MONTHS'}
          data-testid={suffixTestId('vehicleAgeFrom', props)}
        />
        <FormField
          control={props.control}
          name="vehicleAgeTo"
          type="integer"
          label={i18n.t('entity.customerContract.labels.ageTo')}
          isDisabled={vehicleAgeType !== 'VEHICLE_AGE_IN_MONTHS'}
          data-testid={suffixTestId('vehicleAgeTo', props)}
        />
      </Grid>
    </VStack>
  );
}
